<template>
  <div class="container">
    <div>
      <MainText class="title" text="Publications" />
    </div>
    <div>
      <Publication
        title="Optimizing Edge Offloading Decisions for Object Detection"
        conference="ACM/IEEE Symposium on Edge Computing (SEC 2024)"
        :authors="[
          { name: 'Jiaming Qiu', link: '' },
          { name: 'Ruiqi Wang', link: '' },
          { name: 'Brooks Hu', link: '' },
          { name: 'Roch Guérin', link: 'https://rochguerin.github.io/' },
          { name: 'Chenyang Lu', link: 'https://www.cse.wustl.edu/~lu/' },
        ]"
        paper=""
        video=""
        slides=""
      />
      <Publication
        title="On the Benefits of Traffic “Reprofiling” - The Multiple Hops Case - Part I"
        conference="IEEE/ACM Transactions on Networking (ToN 2024)"
        :authors="[
          { name: 'Jiaming Qiu', link: '' },
          { name: 'Jiayi Song', link: '' },
          { name: 'Roch Guérin', link: 'https://rochguerin.github.io/' },
          { name: 'Henry Sariowan', link: '' },
        ]"
        paper="https://arxiv.org/pdf/2404.09087"
        video=""
        slides=""
      />
      <Publication
        title="Adaptive Edge Offloading for Image Classification under Rate Limit"
        conference="ACM SIGBED International Conference on Embedded Software (EMSOFT 2022)"
        :authors="[
          { name: 'Jiaming Qiu', link: '' },
          { name: 'Ruiqi Wang', link: '' },
          { name: 'Ayan Chakrabarti', link: 'https://projects.ayanc.org/' },
          { name: 'Roch Guérin', link: 'https://rochguerin.github.io/' },
          { name: 'Chenyang Lu', link: 'https://www.cse.wustl.edu/~lu/' },
        ]"
        paper="https://ieeexplore.ieee.org/document/9852802"
        video="https://drive.google.com/file/d/1vBp9K2hzNUGaPQejJ_xR40FMSCh76qtu"
        slides="https://docs.google.com/presentation/d/1_tz3UT7ev9F0JMhv3vZH-8oE2gD6R0rI"
      />
      <Publication
        title="On the Benefits of Traffic “Reprofiling” the Single Hop Case"
        conference="IEEE/ACM Transactions on Networking (ToN 2024)"
        :authors="[
          { name: 'Jiayi Song', link: '' },
          { name: 'Jiaming Qiu', link: '' },
          { name: 'Roch Guérin', link: 'https://rochguerin.github.io/' },
          { name: 'Henry Sariowan', link: '' },
        ]"
        paper="https://ieeexplore.ieee.org/document/10423425"
        video=""
        slides=""
      />
      <Publication
        title="Progressive Neural Compression for Adaptive Image Offloading under Timing Constraints"
        conference="IEEE Real-Time Systems Symposium (RTSS 2023)"
        award="[Best Student Paper]"
        :authors="[
          { name: 'Ruiqi Wang', link: '' },
          { name: 'Hanyang Liu', link: 'https://sites.google.com/view/hliu/home/' },
          { name: 'Jiaming Qiu', link: '' },
          { name: 'Moran Xu', link: '' },
          { name: 'Roch Guérin', link: 'https://rochguerin.github.io/' },
          { name: 'Chenyang Lu', link: 'https://www.cse.wustl.edu/~lu/' },
        ]"
        paper="https://ieeexplore.ieee.org/document/10405983"
        video=""
        slides="https://gowustl-my.sharepoint.com/:p:/g/personal/ruiqi_w_wustl_edu/EbD4uyx9L8JIld6P_BEnflgBo_oX7kOM9NcJ7isI3x_iNg?e=xXhQnd"
      />
      <Publication
        title="Intensification of Hydrological Drought Due to Human Activity in the Middle Reaches of the Yangtze River, China"
        conference="Science of the Total Environment (STOTEN 2018)"
        :authors="[
          { name: 'Dan Zhang', link: '' },
          { name: 'Qi Zhang', link: '' },
          { name: 'Jiaming Qiu', link: '' },
          { name: 'Peng Bai', link: '' },
          { name: 'Kang Liang', link: '' },
          { name: 'Xianghu Li', link: '' },
        ]"
        paper="https://doi.org/10.1016/j.scitotenv.2018.05.121"
        video=""
        slides=""
      />
    </div>
  </div>
</template>

<script>
import MainText from "../components/MainText";
import Publication from "../components/Publication";

export default {
  name: "Publications",
  components: {
    MainText,
    Publication,
  },
};
</script>

<style scoped>
.container {
  position: absolute;
  top: 90px;
  left: 360px;
  padding-left: 60px;
  padding-right: 90px;
  display: flex;
  flex-wrap: wrap;
}
p {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #212325;
  font-size: 20px;
  line-height: 150%;
  text-align: justify;
}
@media (max-width: 1000px) {
  div.container {
    top: 120px;
    left: 0;
    padding-right: 60px;
  }
  p.title {
    font-size: 30px;
    margin-bottom: 20px;
  }
}
@media (max-width: 600px) {
  div.container {
    padding-left: 30px;
    padding-right: 30px;
  }
  p.title {
    font-size: 25px;
    margin-bottom: 15px;
  }
}
</style>